export default "__VITE_ASSET__CfpG4E7N__"